import { useCallback } from "react"
import { IProduto, IProdutoTipoConsumo } from "../../application/models"
import { useAxiosInstances } from "../axios-instance"

export const useProdutoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const getProdutosByIdUsuarioApi = useCallback(async (data: {
        IdUsuario: number
    }): Promise<IProduto[]> => {
        try {
            const result = await axiosAuthInstance.get(`/produto/usuario/${data.IdUsuario}`)
            return result.data.produtos
        }

        catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const getAllProdutosAndTipoConsumosApi = useCallback(async (data: {

    }): Promise<IProdutoTipoConsumo[]> => {
        try {
            const result = await axiosAuthInstance.get('/produto/produtoTipoConsumo', {})

            return result.data.produtos
        }

        catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    const getProdutoClienteByIdClienteApi = useCallback(async (data: {
        IdCliente: number
        Ativo: boolean

    }): Promise<{
        IdProduto: number
        IdTipoConsumo: number
        TipoConsumoAtivo?: boolean
    }[]> => {
        try {
            const result = await axiosAuthInstance.get('/produtoCliente/produtosCliente', {
                params: {
                    IdCliente: data.IdCliente,
                    Ativo: true,

                }
            })

            return result.data.produtosTipoConsumo
        }
        catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        getProdutosByIdUsuarioApi,
        getAllProdutosAndTipoConsumosApi,
        getProdutoClienteByIdClienteApi
    }
}